/**
 * The three reassurance lines under the preview, matched to what is actually
 * being sold.
 *
 * They used to be hardcoded to canvas, so a paper print was advertised as
 * "stretched on a wooden frame" and "ready to hang". A rolled paper print is
 * neither — it arrives in a tube. Promising a frame the parcel does not
 * contain is worse than saying nothing, and it is the kind of claim a customer
 * only discovers after paying.
 *
 * The colour claim holds for every material; the other two depend on whether
 * the piece is stretched. Nothing selected yet falls back to the paper copy,
 * because the safe default is the one that promises least.
 */
export function trustPointKeys(
  material: string | undefined | null,
  mount: string | undefined | null,
): string[] {
  const isCanvas = material === "canvas";
  const stretched = mount === "stretched";

  // Stretched canvas is the only thing that arrives on a frame, ready to hang.
  if (isCanvas && stretched) {
    return ["canvasTrustQuality", "canvasTrustWrap", "canvasTrustReady"];
  }
  // Rolled canvas is still canvas: it must not be sold as photo paper, even
  // though it shares paper's "not framed, frame it yourself" story.
  if (isCanvas) {
    return ["canvasTrustQuality", "canvasTrustStock", "paperTrustFraming"];
  }
  return ["canvasTrustQuality", "paperTrustStock", "paperTrustFraming"];
}
